import { MyActivityImpl } from '../../API/my-activities/implements/my-activity.impl';

export interface MyActivitiesState {
  myActivities: MyActivityImpl[];
  selectedActivityPayments: MyActivityPayment[];
  pagination: MyActivitiesStatePagination;
}

export enum MyActivitiesType {
  PAST = 'past',
  FUTURE = 'future',
}

export interface MyActivityOrderItem {
  id: number;
  policyId: number;
  fromDate: number;
  toDate: number;
}

export interface MyActivitiesStatePagination {
  eventsTotalResult: number;
  roomsTotalResult: number;
  eventsShown: number;
  roomsShown: number;
}

export interface MyActivityPayment {
  id: number;
  orderId: number;
  paymentStatus: string;
  cashAmount: number;
  creditAmount: number;
  creditBalanceId: number;
  isTokenPayment: boolean;
  discount: number;
  sum: number;
}
